<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      中创
      <small>/详情管理</small>
    </h1>

    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-left:0px;padding-right:0px;padding-top: 0px"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">商品详情列表</h4>
              </div>
              <!-- end panel-heading -->
              <form  style="padding-top:25px;">
                <fieldset>
                  <div class="form-group row m-b-15">
                    <label class="col-md-1 col-form-label">品牌</label>
                    <div class="col-md-2">
                     <select class="form-control" >
											<option value="1" style="display:none">请输入品牌</option>
                      <option value="2">2VEE(628)</option>
                      <option value="3">A2(508)</option>
										</select>
                    </div>
                    <label class="col-md-1 col-form-label">商品</label>
                    <div class="col-md-2">
                      <select class="form-control" >
											<option value="1" style="display:none">请输入商品</option>
                      <option value="2">新西兰 A2婴幼儿奶粉</option>
										</select>
                    </div>
                    <div class="col-md-2">
                      <button type="submit" class="btn btn-primary m-r-5">搜索</button>
                    </div>
                  </div>
                  <div class="form-group row m-b-15"></div>
                </fieldset>
              </form>
              <!-- begin panel-body -->
              <div class="panel-body">
                <el-table :data="StoreGoodsList" border style="width: 100%">
                  <el-table-column prop="id" label="ID" align="center"></el-table-column>
                  <el-table-column prop="name" label="商品名称" align="center"></el-table-column>
                  <el-table-column prop="pzncode" label="PZN_CODE" align="center"></el-table-column>
                  <el-table-column prop="code" label="条形码" align="center"></el-table-column>
                  <el-table-column prop="DescriptionChart" label="商品说明图" align="center"></el-table-column>
                  <el-table-column prop="EditAttribute" label="编辑属性" align="center"></el-table-column>
                  <el-table-column label="操作" width="180">
                    <template></template>
                  </el-table-column>
                </el-table>
                <div style="float:right;margin-top:8px;">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="1"
                  ></el-pagination>
                </div>
                <div class="clear"></div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreGoods",
  data() {
    return {
      currentPage: 1,
      StoreGoodsList: [],
      value: "",
      value2: ""
    };
  },
  mounted: function() {
   
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/CommoditiesList/StoreGoods.vue